import React from "react"
import GoTop from "./GoTop"

const Layout = ({children}) => {
    return (
        <>
            {children}
            <GoTop scrollStepInPx="100" delayInMs="10.50"/>
            {/*<div*/}
            {/*    key={`body`}*/}
            {/*    id="___gatsby"*/}
            {/*    dangerouslySetInnerHTML={{__html: `<!-- Start of HubSpot Embed Code --> <script type="text/javascript" id="hs-script-loader" async defer src="//js.hs-scripts.com/23285786.js"/> <!-- End of HubSpot Embed Code -->`}}*/}
            {/*/>*/}
        </>
    )
}
export default Layout
